import {
  Exceptiondt2hlxn7j7vw as Exception,
  VOID3gxj6tk5isa35 as VOID,
  Exception_init_$Init$393utbttlf2x4 as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  hashCodeq5arwsb9dgti as hashCode,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Charsets_getInstanceqs70pvl4noow as Charsets_getInstance,
  forName2faodmskqnoz5 as forName,
  isSupported2nf870ypy50et as isSupported,
} from './ktor-ktor-io.mjs';
import {
  HttpHeaders_getInstanceelogg8fjd54u as HttpHeaders_getInstance,
  parseAndSortHeader33xgq5fx7y6j1 as parseAndSortHeader,
  NullBody_instance2i6w0hfghwfg0 as NullBody_instance,
} from './ktor-ktor-http.mjs';
import {
  FlowCollector26clgpmzihvke as FlowCollector,
  asFlow3ngsnn5xpz8pw as asFlow,
  firstOrNull3jjcu7fygcopr as firstOrNull,
} from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(ContentConvertException, 'ContentConvertException', VOID, Exception);
initMetadataForClass(JsonConvertException, 'JsonConvertException', VOID, ContentConvertException);
function register$default(contentType, converter, configuration, $super) {
  var tmp;
  if (configuration === VOID) {
    tmp = Configuration$register$lambda;
  } else {
    tmp = configuration;
  }
  configuration = tmp;
  var tmp_0;
  if ($super === VOID) {
    this.i4g(contentType, converter, configuration);
    tmp_0 = Unit_instance;
  } else {
    tmp_0 = $super.i4g.call(this, contentType, converter, configuration);
  }
  return tmp_0;
}
initMetadataForInterface(Configuration, 'Configuration');
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForLambda(deserialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
initMetadataForClass(deserialize$$inlined$map$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForLambda(deserialize$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($deserializeCOROUTINE$, CoroutineImpl);
//endregion
function ContentConvertException(message, cause) {
  cause = cause === VOID ? null : cause;
  Exception_init_$Init$(message, cause, this);
  captureStack(this, ContentConvertException);
}
function JsonConvertException(message, cause) {
  cause = cause === VOID ? null : cause;
  ContentConvertException.call(this, message, cause);
  captureStack(this, JsonConvertException);
}
function deserialize(_this__u8e3s4, body, typeInfo, charset, $completion) {
  var tmp = new $deserializeCOROUTINE$(_this__u8e3s4, body, typeInfo, charset, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function suitableCharset(_this__u8e3s4, defaultCharset) {
  defaultCharset = defaultCharset === VOID ? Charsets_getInstance().g2u_1 : defaultCharset;
  var tmp0_elvis_lhs = suitableCharsetOrNull(_this__u8e3s4, defaultCharset);
  return tmp0_elvis_lhs == null ? defaultCharset : tmp0_elvis_lhs;
}
function Configuration$register$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Configuration() {
}
function suitableCharsetOrNull(_this__u8e3s4, defaultCharset) {
  defaultCharset = defaultCharset === VOID ? Charsets_getInstance().g2u_1 : defaultCharset;
  var _iterator__ex2g4s = parseAndSortHeader(_this__u8e3s4.g1c(HttpHeaders_getInstance().m35_1)).l();
  while (_iterator__ex2g4s.m()) {
    var charset = _iterator__ex2g4s.n().wf();
    if (charset === '*')
      return defaultCharset;
    else if (isSupported(Charsets_getInstance(), charset))
      return forName(Charsets_getInstance(), charset);
  }
  return null;
}
function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
  this.k4g_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).n2e = function (value, $completion) {
  return this.k4g_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).r2 = function () {
  return this.k4g_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.r2(), other.r2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
  return hashCode(this.r2());
};
function deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
  this.t4g_1 = $$this$unsafeFlow;
  this.u4g_1 = $charset;
  this.v4g_1 = $typeInfo;
  this.w4g_1 = $body;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(deserialize$o$collect$slambda).z4g = function (value, $completion) {
  var tmp = this.a4h(value, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(deserialize$o$collect$slambda).x8 = function (p1, $completion) {
  return this.z4g((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(deserialize$o$collect$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var tmp0 = this.t4g_1;
          var tmp2 = this.x4g_1;
          this.y4g_1 = tmp0;
          this.d8_1 = 1;
          suspendResult = tmp2.b4h(this.u4g_1, this.v4g_1, this.w4g_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          this.d8_1 = 2;
          suspendResult = this.y4g_1.n2e(ARGUMENT, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(deserialize$o$collect$slambda).a4h = function (value, completion) {
  var i = new deserialize$o$collect$slambda(this.t4g_1, this.u4g_1, this.v4g_1, this.w4g_1, completion);
  i.x4g_1 = value;
  return i;
};
function deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
  var i = new deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation);
  var l = function (value, $completion) {
    return i.z4g(value, $completion);
  };
  l.$arity = 1;
  return l;
}
function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.k4h_1 = _this__u8e3s4;
  this.l4h_1 = collector;
}
protoOf($collectCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var $this$unsafeFlow = this.l4h_1;
          this.d8_1 = 1;
          var tmp_0 = deserialize$o$collect$slambda_0($this$unsafeFlow, this.k4h_1.n4h_1, this.k4h_1.o4h_1, this.k4h_1.p4h_1, null);
          suspendResult = this.k4h_1.m4h_1.p2e(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function deserialize$$inlined$map$1($this, $charset, $typeInfo, $body) {
  this.m4h_1 = $this;
  this.n4h_1 = $charset;
  this.o4h_1 = $typeInfo;
  this.p4h_1 = $body;
}
protoOf(deserialize$$inlined$map$1).o2e = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$(this, collector, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(deserialize$$inlined$map$1).p2e = function (collector, $completion) {
  return this.o2e(collector, $completion);
};
function deserialize$slambda($body, resultContinuation) {
  this.y4h_1 = $body;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(deserialize$slambda).a4i = function (it, $completion) {
  var tmp = this.a4h(it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(deserialize$slambda).x8 = function (p1, $completion) {
  return this.a4i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(deserialize$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        return !(this.z4h_1 == null) || this.y4h_1.r2l();
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(deserialize$slambda).a4h = function (it, completion) {
  var i = new deserialize$slambda(this.y4h_1, completion);
  i.z4h_1 = it;
  return i;
};
function deserialize$slambda_0($body, resultContinuation) {
  var i = new deserialize$slambda($body, resultContinuation);
  var l = function (it, $completion) {
    return i.a4i(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function $deserializeCOROUTINE$(_this__u8e3s4, body, typeInfo, charset, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.e4g_1 = _this__u8e3s4;
  this.f4g_1 = body;
  this.g4g_1 = typeInfo;
  this.h4g_1 = charset;
}
protoOf($deserializeCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          var this_0 = asFlow(this.e4g_1);
          var tmp_0 = new deserialize$$inlined$map$1(this_0, this.h4g_1, this.g4g_1, this.f4g_1);
          suspendResult = firstOrNull(tmp_0, deserialize$slambda_0(this.f4g_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var tmp_1;
          if (!(result == null)) {
            tmp_1 = result;
          } else {
            if (!this.f4g_1.r2l()) {
              tmp_1 = this.f4g_1;
            } else {
              var tmp0_safe_receiver = this.g4g_1.s31_1;
              if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ua()) === true) {
                tmp_1 = NullBody_instance;
              } else {
                throw new ContentConvertException('No suitable converter found for ' + this.g4g_1.toString());
              }
            }
          }

          return tmp_1;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
//region block: exports
export {
  deserialize as deserialize3kqe4vxpbxz1,
  register$default as register$default3vdkjcc7m2cj0,
  Configuration as Configuration20xgygxdzhlk5,
  JsonConvertException as JsonConvertExceptiongnc5x6xwaf77,
  suitableCharset as suitableCharset1jgdcpdzbzgzn,
};
//endregion

//# sourceMappingURL=ktor-ktor-serialization.mjs.map
